
import { Component, Prop, Vue } from 'vue-property-decorator'
import ImageBase from '@/components/atoms/ImageBase.vue'
import TitlePage from '@/components/atoms/TitlePage.vue'
import ButtonStrongHover from '@/components/molecules/ButtonStrongHover.vue'
import ButtonStrongReverse from '@/components/molecules/ButtonStrongReverse.vue'
import ButtonSubmitSquare from '@/components/molecules/ButtonSubmitSquare.vue'
import ButtonOptionalSquare from '@/components/molecules/ButtonOptionalSquare.vue'
import QuestionResultArea from '@/components/organisms/QuestionResultArea.vue'
import QuestionResultTip from '@/components/organisms/QuestionResultTip.vue'
import ButtonInput from '@/components/organisms/study/ButtonInput.vue'
import MemoArea from '@/components/organisms/study/MemoArea.vue'
import ModalStylePageLayout from '@/components/organisms/layout/ModalStylePageLayout.vue'
import { StudyModel } from '@/models/StudyModel'
import { DrawingModel } from '@/models/DrawingModel'
import { CurriculumUnit } from '@/models/CurriculumUnit'

/**
 * 小問演習結果画面のテンプレート
 */
@Component({
  components: {
    ImageBase,
    TitlePage,
    ButtonStrongHover,
    ButtonStrongReverse,
    ButtonSubmitSquare,
    ButtonOptionalSquare,
    QuestionResultArea,
    QuestionResultTip,
    ButtonInput,
    MemoArea,
    ModalStylePageLayout,
  },
})
export default class LearningProblem extends Vue {
  /** 単元情報 */
  @Prop()
  curriculumUnit!: CurriculumUnit

  /** 小問情報 */
  @Prop()
  problem!: StudyModel.Problem

  /** 復習BOX登録済みフラグ */
  @Prop()
  isProblemSaved!: boolean

  /** 復習BOX登録ボタンクリック時イベント */
  @Prop()
  eventSaveProblem!: () => Promise<void>

  /** 復習BOX登録解除ボタンクリック時イベント */
  @Prop()
  eventRemoveProblem!: () => Promise<void>

  /** 戻るボタンクリック時イベント */
  @Prop()
  eventReturn!: () => Promise<void>

  /** トップページボタンクリック時イベント */
  @Prop()
  eventTopPage!: () => Promise<void>

  /** メモのストローク情報 */
  @Prop()
  private memoStrokes?: DrawingModel.Stroke[]

  /** メモエリアの表示状態 */
  private isShowMemoArea = false

  /**
   * メモ機能の有効/無効
   *
   * @returns 有効状態
   */
  private get enableMemo(): boolean {
    return !!process.env.VUE_APP_ENABLE_MEMO
  }

  /**
   * メモエリアの表示切り替え
   */
  private toggleMemoArea(): void {
    this.isShowMemoArea = !this.isShowMemoArea
  }

  /**
   * メモエリアの非表示化
   */
  private hideMemoArea(): void {
    this.isShowMemoArea = false
  }
}
